import "@sms/design-system/tokens/global.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("gate-app: #root missing in index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register the app-shell service worker. We skip registration in dev
// (Vite serves source modules that the SW can't usefully cache, and
// the dev hot-reload conflicts with cached navigations); production
// builds enable it. The check is `import.meta.env.PROD` so vitest /
// jsdom don't try to register against an unsupported environment.
if (typeof window !== "undefined" && import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      // Registration failures are not user-facing — the app still
      // works without the SW, it just loses the cold-start cache.
      console.warn("gate-app: SW registration failed", err);
    });
  });
}
